import styled, { css } from 'styled-components';
import GptIcon from 'components/Icons/gpt.svg';
import { useIsOnline, useSyncManagerState } from 'hooks';
import { useFormVehicleId } from 'pages/ListerVehicleUploadV2/hooks/useFormVehicleId';
import { SyncManager } from 'db';
import { useVehicleEditing } from 'context/isAnotherUserEditingContext';

const disabledCss = css`
  opacity: 0.7;
  pointer-events: none;
`;

const UseAiWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  ${props => props.disabled && disabledCss}
`;

const Text = styled.span`
  font-weight: 600;
  font-size: 12px;
  line-height: 100%;
  color: #000;
`;

const UseButton = styled.div<{ bg: string; disabled: boolean }>`
  border-radius: 8px;
  background: ${props => props.bg};
  opacity: ${props => (props.disabled ? '0.7' : 1)};
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 12px;
  line-height: 16px;
  min-width: 72px;
  padding: 4px 12px;
  height: 24px;
  margin-left: auto;
  cursor: pointer;
`;

type UseAiProps = {
  bg: string;
  text: string;
  handleClick: () => void | Promise<void>;
};

export const UseAiTextButton = ({ handleClick, bg, text }: UseAiProps) => {
  const isOnline = useIsOnline();
  const vehicleId = useFormVehicleId();
  const syncManager = SyncManager.getInstance(vehicleId);

  const { hasAnotherEditor } = useVehicleEditing();

  const onClick = async () => {
    if (!isOnline) return;
    await syncManager.waitUntilSynced();
    handleClick();
  };

  return (
    <UseAiWrapper disabled={hasAnotherEditor}>
      <GptIcon />
      <Text>AI Generated Text</Text>
      <UseButton disabled={!isOnline} bg={bg} onClick={onClick}>
        {text}
      </UseButton>
    </UseAiWrapper>
  );
};
